// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2_D2Q","rootMobile":"styles_rootMobile___36RB"};